import { render, staticRenderFns } from "./UserCardRights.vue?vue&type=template&id=69279b77&scoped=true"
import script from "./UserCardRights.vue?vue&type=script&lang=ts"
export * from "./UserCardRights.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69279b77",
  null
  
)

export default component.exports